<script setup>
import { ref, useTemplateRef } from "vue";
import useStickToElement from "../../../composables/useStickToElement";
import { onClickOutside } from "#imports";
const dropdownRef = ref();
const dropdownButtonRef = ref();
const dropdownElements = useTemplateRef("dropdownElements");
const setSlotButtonRef = (el) => {
  dropdownButtonRef.value = el?.$el;
};
const props = defineProps({
  responsiveSwitch: {
    type: Boolean,
    default: false
  },
  position: {
    type: String,
    default: "right"
  },
  positionY: {
    type: String,
    default: "bottom"
  },
  noPadding: {
    type: Boolean,
    default: false
  },
  size: {
    type: String,
    default: "md"
  }
});
const emit = defineEmits(["showDropdown"]);
const shown = defineModel({ type: Boolean, ...{
  default: false
} });
const close = () => {
  shown.value = false;
  emit("showDropdown", shown.value);
};
const toggleShowList = () => {
  shown.value = !shown.value;
  emit("showDropdown", shown.value);
};
const { positionStyle } = useStickToElement(
  dropdownButtonRef,
  dropdownElements,
  shown,
  props.position,
  props.positionY,
  props.responsiveSwitch,
  void 0,
  true
);
onClickOutside(dropdownElements, close, {
  ignore: [dropdownButtonRef]
});
</script>

<template>
    <div ref="dropdownRef" class="chargemap-dropdown">
        <slot
            name="button"
            :set-button-ref="setSlotButtonRef"
            :toggle-show-list
        />

        <Transition>
            <Teleport to="body">
                <div
                    v-if="shown"
                    ref="dropdownElements"
                    class="chargemap-dropdown fixed mt-1 z-[50] min-w-64 rounded-lg border border-slate-100 bg-white shadow-lg ring-opacity-5 focus:outline-none transition-opacity duration-150"
                    :class="!noPadding && 'p-2'"
                    :style="positionStyle"
                    role="menu"
                    aria-orientation="vertical"
                    aria-labelledby="menu-button"
                    tabindex="-1"
                >
                    <div
                        ref="dropdownActionsRef"
                        class="actions-list [&>*]:rounded-md flex flex-col gap-1 transition-all duration-150 transform"
                        :class="size"
                        role="none"
                    >
                        <slot name="actionsList" :toggle-show-list />
                    </div>

                    <slot />
                </div>
            </Teleport>
        </Transition>
    </div>
</template>

<style>
.chargemap-dropdown .filters-trigger {
  @apply inline-flex items-center	justify-between	gap-2 w-full lg:min-w-60 h-full rounded-md px-4 py-2 font-medium text-slate-800 text-sm bg-white hover:bg-slate-50 shadow focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-offset-slate-100 focus:ring-primary-500;
}
.chargemap-dropdown .actions-list button {
  @apply flex
                gap-2
                w-full
                rounded-md
                transition
                duration-150
                ease-in-out
                hover:bg-slate-50
                text-slate-800
                focus:outline-none;
}
.chargemap-dropdown .actions-list.sm button {
  @apply text-sm leading-[21px] tracking-[-0.42px] p-2;
}
.chargemap-dropdown .actions-list.md button {
  @apply leading-6 font-medium tracking-[-0.48px] p-2.5;
}
.chargemap-dropdown .filters-button {
  @apply flex gap-2 w-full p-2.5 leading-5 rounded-md transition duration-150 ease-in-out hover:bg-slate-50 focus:outline-none;
}
.chargemap-dropdown .filters-button svg {
  @apply invisible;
}
.chargemap-dropdown .filters-button--selected {
  @apply text-primary-600;
}
.chargemap-dropdown .filters-button--selected svg {
  @apply visible;
}

.v-enter-active,
.v-leave-active {
  transition: opacity 0.2s ease;
}

.v-enter-from,
.v-leave-to {
  opacity: 0;
}
</style>
